import React from 'react';

// Opera Cloud's credit-card authorization rules are the fixed set 1-9 — each number is a built-in formula
// (e.g. 2 = "Nights * (Daily Rate + Amount)"), and the property configures the Amount that feeds it.
// So the code is a closed list and the amount is free text.
//
// This was briefly replaced by a picker reading /fof/config/v1/authorizationConfigRules, but that endpoint
// returned only a subset of the configured rules (NYP returned 1 of 9). Reverted to the fixed list while an
// Oracle support case is open — see the DISABLED note in
// lambdas/lambda-src/ui-v2/src/hc/paymentporter/paymentporter/ohip-lov.js.
//
// Shared by EditRoutingPage, AddRoutingPage and PMMAddRoutingPage so the list exists once. Omit `amount`
// (and `onAmountChange`) to render the code on its own — PMM has no authorization_amount column.
export const AUTH_RULE_CODES = ['1', '2', '3', '4', '5', '6', '7', '8', '9'];

// Blank is valid ("no amount configured"). Anything else must be a non-negative number, because it is sent
// to OHIP as the authorization amount — a bad value there is a wrong card authorisation, not a UI glitch.
export const validateAuthorizationAmount = (amount) => {
    if (amount === '' || amount == null) return undefined;
    const num = Number(amount);
    if (Number.isNaN(num)) return 'Amount must be a number';
    if (num < 0) return 'Amount cannot be negative';
    return undefined;
};

const AuthorizationRuleFields = ({ code, onCodeChange, amount, onAmountChange, amountError }) => {
    const showAmount = onAmountChange != null;
    return (
        <>
            <div className="acp-field">
                <label className="acp-label">Authorization Rule Code</label>
                <select
                    className="acp-select"
                    value={code || ''}
                    onChange={e => onCodeChange(e.target.value)}
                >
                    <option value="">— None —</option>
                    {AUTH_RULE_CODES.map(c => <option key={c} value={c}>{c}</option>)}
                </select>
            </div>

            {showAmount && (
                <div className="acp-field">
                    <label className="acp-label">Authorization Amount</label>
                    <input
                        className={`acp-input${amountError ? ' acp-input-error' : ''}`}
                        type="number"
                        min="0"
                        step="0.01"
                        placeholder="e.g. 200.00"
                        value={amount ?? ''}
                        onChange={e => onAmountChange(e.target.value)}
                        // The rule code is what OHIP applies; an amount with no rule is silently ignored,
                        // so the field is disabled rather than accepting a value that goes nowhere.
                        disabled={!code}
                    />
                    {amountError
                        ? <span className="acp-error-msg">{amountError}</span>
                        : <span className="acp-hint">
                            {code
                                ? 'Optional. Sent to Opera Cloud as the rule’s amount when the card is moved. Leave blank to send the rule code alone.'
                                : 'Select an authorization rule code first.'}
                        </span>}
                </div>
            )}
        </>
    );
};

export default AuthorizationRuleFields;
